import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

export default function Feedback() {
  return (
    <main data-testid="feedback-page">
      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
          <SectionHeading
            eyebrow="Complaints & Feedback"
            title="Your feedback matters"
            lead="Compliments, concerns and complaints help us provide safer, better care. You will always be treated with respect when you speak up."
          />
        </div>
      </section>
      <section className="bg-euca-mist">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 space-y-8">
          <Reveal>
            <div className="rounded-2xl border border-euca-line bg-white p-7 sm:p-8">
              <h2 className="font-serif text-2xl font-medium text-euca-dark">How to give feedback</h2>
              <p className="mt-3 text-base leading-relaxed text-mutedsoft">
                You can share feedback directly with your practitioner, by emailing{" "}
                <a href="mailto:hello@eucalypttherapy.com.au" className="font-semibold text-euca hover:underline" data-testid="feedback-email">
                  hello@eucalypttherapy.com.au
                </a>
                , by calling 0417 508 502, or through the enquiry form. You are welcome to have a support person
                assist you.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="rounded-2xl border border-euca-line bg-white p-7 sm:p-8">
              <h2 className="font-serif text-2xl font-medium text-euca-dark">What happens next</h2>
              <p className="mt-3 text-base leading-relaxed text-mutedsoft">
                We acknowledge complaints within two business days and aim to resolve them as quickly as possible.
                Raising a concern will never affect the care you receive.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="rounded-2xl border border-euca-line bg-white p-7 sm:p-8">
              <h2 className="font-serif text-2xl font-medium text-euca-dark">External options</h2>
              <p className="mt-3 text-base leading-relaxed text-mutedsoft">
                If you are not satisfied with our response, you can contact the Office of the Health Ombudsman
                (Queensland) on 133 646, the NDIS Quality and Safeguards Commission on 1800 035 544 for NDIS
                services, or the Australian Association of Social Workers regarding professional conduct.
              </p>
              <Link
                to="/contact"
                data-testid="feedback-contact-button"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-euca px-7 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-euca-dark"
              >
                Send feedback <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
